'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponsibleGaming = void 0;
var transport_1 = require("../../transport");
var ResponsibleGaming = /** @class */ (function () {
    function ResponsibleGaming() {
    }
    ResponsibleGaming.prototype.getTimeoutCategories = function () {
        return transport_1.transport.request('responsiblegaming/getTimeoutCategories');
    };
    ResponsibleGaming.prototype.getTimeoutDurations = function () {
        return transport_1.transport.request('responsiblegaming/getTimeoutDurations');
    };
    ResponsibleGaming.prototype.getSelfExclusionPeriods = function () {
        return transport_1.transport.request('responsiblegaming/getSelfExclusionPeriodsV2');
    };
    ResponsibleGaming.prototype.enableSelfExclusion = function (params) {
        return transport_1.transport.request('responsiblegaming/enableSelfExclusionV2', params);
    };
    ResponsibleGaming.prototype.getSelfExclusionURL = function () {
        return transport_1.transport.request('responsiblegaming/getSelfExclusionURL');
    };
    ResponsibleGaming.prototype.enableSelfExclusionCoolOff = function (params) {
        return transport_1.transport.request('responsiblegaming/enableSelfExclusionCoolOff', params);
    };
    ResponsibleGaming.prototype.createUserSuspensionLimitSelfExclude = function (params) {
        return transport_1.transport.request('corex/create-user-suspension-limit', params);
    };
    ResponsibleGaming.prototype.enableLotbaPanicSelfExclusion = function () {
        return transport_1.transport.request('responsibleGaming/AddPanicSelfExclusion');
    };
    ResponsibleGaming.prototype.setUserLimits = function (params) {
        return transport_1.transport.request('responsiblegaming/setUserLimitsV2', params);
    };
    ResponsibleGaming.prototype.getUserLimits = function (params) {
        return transport_1.transport.request('responsiblegaming/getUserLimitsV2', params);
    };
    ResponsibleGaming.prototype.removeLimit = function (params) {
        return transport_1.transport.request('responsiblegaming/RemoveLimit', params);
    };
    ResponsibleGaming.prototype.getUserPlayStatsAndLimits = function (params) {
        return transport_1.transport.request('responsiblegaming/userPlayStatsAndLimits', params);
    };
    ResponsibleGaming.prototype.getLimits = function () {
        return transport_1.transport.request('responsiblegaming/getLimitsV2');
    };
    ResponsibleGaming.prototype.awaitingUserLimitConfirmation = function () {
        return transport_1.transport.request('responsiblegaming/awaitingUserLimitConfirmation');
    };
    ResponsibleGaming.prototype.confirmUserLimits = function (payload) {
        return transport_1.transport.request('responsiblegaming/confirmUserLimits', payload);
    };
    ResponsibleGaming.prototype.getUserTransactionLimits = function () {
        return transport_1.transport.request('corex/get-user-transaction-limits');
    };
    ResponsibleGaming.prototype.getMaxWagerLimits = function () {
        return transport_1.transport.request('corex/get-max-wager-limits');
    };
    ResponsibleGaming.prototype.getAllUserCumulativeSessionLimits = function () {
        return transport_1.transport.request('corex/get-all-user-cumulative-session-limits');
    };
    ResponsibleGaming.prototype.createUserSuspensionLimit = function (params) {
        return transport_1.transport.request('corex/create-user-suspension-limit', params);
    };
    ResponsibleGaming.prototype.createUserCumulativeSessionLimit = function (params) {
        return transport_1.transport.request('corex/create-user-cumulative-session-limit', params);
    };
    ResponsibleGaming.prototype.createUserTransactionLimit = function (params) {
        return transport_1.transport.request('corex/create-user-transaction-limit', params);
    };
    ResponsibleGaming.prototype.cancelUserTransactionLimit = function (params) {
        return transport_1.transport.request('corex/cancel-user-transaction-limit', params);
    };
    ResponsibleGaming.prototype.createUserWagerLimit = function (params) {
        return transport_1.transport.request('corex/create-user-wager-limit', params);
    };
    ResponsibleGaming.prototype.reviewTransactionLimit = function (params) {
        return transport_1.transport.request('corex/review-transaction-limit', params);
    };
    ResponsibleGaming.prototype.reviewMaxWagerLimit = function (params) {
        return transport_1.transport.request('corex/review-max-wager-limit', params);
    };
    ResponsibleGaming.prototype.reviewCumulativeSessionLimit = function (params) {
        return transport_1.transport.request('corex/review-cumulative-session-limit', params);
    };
    ResponsibleGaming.prototype.getUserRestrictions = function (params) {
        return transport_1.transport.request('corex/get-user-restrictions', params);
    };
    return ResponsibleGaming;
}());
exports.ResponsibleGaming = ResponsibleGaming;
